function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExternalview = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M3,16h8.42a3,3,0,0,0,3-3V7.8a.68.68,0,0,0-.67-.7h0a.68.68,0,0,0-.7.67V13a1.63,1.63,0,0,1-1.62,1.64H3A1.63,1.63,0,0,1,1.4,13V4.52A1.64,1.64,0,0,1,3,2.88H8.18a.71.71,0,1,0,0-1.41H3a3,3,0,0,0-3,3H0V13A3,3,0,0,0,3,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M16,5V.72a.24.24,0,0,0,0-.14s0,0,0,0,0-.05,0-.07a.1.1,0,0,0,0-.07s0,0,0-.05a.81.81,0,0,0-.18-.19l0,0a.17.17,0,0,0-.14-.09l-.07,0-.14,0H11a.7.7,0,0,0-.71.7.71.71,0,0,0,.71.71h2.6L7.15,7.87a.7.7,0,0,0,0,1,.71.71,0,0,0,1,0l6.46-6.45V5a.68.68,0,0,0,.67.7h0A.73.73,0,0,0,16,5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 16,
    height: 16
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternalview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/external view.c8ffd0c3.svg";
export { ForwardRef as ReactComponent };